import React from 'react';

function getToolId(tool) {
  if (tool == null) return undefined;
  return tool?.id ?? tool?._id?.$oid ?? tool?._id;
}

function getToolName(tool) {
  if (tool == null) return 'Unnamed tool';
  return tool?.name ?? tool?.title ?? 'Unnamed tool';
}

/**
 * Right sidebar: default/available tools list. Add by + to add to template (shows on left).
 */
export default function AvailableToolsSidebar({
  availableTools = [],
  onAddTool,
  loading = false,
  error = null,
}) {
  return (
    <div className="available-tools-sidebar card h-100">
      <div className="card-body">
        <h3 className="available-tools-sidebar__title h6 mb-2">Available tools</h3>
        <p className="available-tools-sidebar__hint text-muted small mb-3">
          Click + to add a tool to this template. It will appear on the left for editing.
        </p>
        {error && (
          <div className="alert alert-danger py-2 small mb-3" role="alert">
            {error}
          </div>
        )}
        {loading ? (
          <div className="d-flex align-items-center justify-content-center py-4">
            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true" />
          </div>
        ) : availableTools.length === 0 ? (
          <p className="text-muted small mb-0">No tools available.</p>
        ) : (
          <ul className="available-tools-sidebar__list list-unstyled mb-0">
            {availableTools.map((tool) => (
              <li key={`avail-${getToolId(tool)}`} className="available-tools-sidebar__item">
                <span className="available-tools-sidebar__item-name">{getToolName(tool)}</span>
                <button
                  type="button"
                  className="available-tools-sidebar__btn-add btn btn-sm"
                  onClick={() => onAddTool?.(tool)}
                  title="Add to template"
                  aria-label={`Add ${getToolName(tool)}`}
                >
                  <i className="bi bi-plus-lg" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
